import React, { useState, useEffect, useMemo } from 'react';

import api from '../services/api';

import { getCmsData } from '../cms/cmsData';

import { useAuth } from '../context/AuthContext';

import toast from '../utils/toast';

import AnnouncementBar from '../components/AnnouncementBar';

import Footer from '../components/Footer';

import SponsorsSection from '../components/SponsorsSection';

import ScrollToTop from '../components/ScrollToTop';

import TornPaperWrapper from '../components/TornPaperWrapper';


import { trackAddToCart } from '../utils/metaPixel';
import './VendorBooths.css';
import { getCmsImagePath } from '../cms/cmsData';
import { getArabicTranslation } from '../utils/arabicTranslations';



const VendorBooths = ({ allowedBooths = null }) => {
  const cms = getCmsData();
  const vb = cms.vendorBoothsPage || {};

  const { user, isAuthenticated } = useAuth();

  

  // All vendor booths are fixed at 3 days - no day selection

  

  const [upgrades, setUpgrades] = useState({

    bazaar: false,

    'food-truck': false,

    'food-booth': false

  });

  

  const [halal, setHalal] = useState({

    'food-truck': false,

    'food-booth': false,

    'food-booth-20x20': false,

    'food-booth-20x10': false

  });



  const [selectedBooth, setSelectedBooth] = useState(null);

  const [showRegistration, setShowRegistration] = useState(false);

  const [formData, setFormData] = useState({

    businessType: 'Arab Boutique',

    firstName: '',

    lastName: '',

    email: '',

    legalName: '',

    boothName: '',

    sameAsLegal: false,

    phone: '',

    instagram: '',

    facebook: '',

    tiktok: '',

    setupAccepted: false,

    handwashAccepted: false,

    presentationAccepted: false,

    bdsAccepted: false,

    rightOfRefusalAccepted: false,

    healthPermit: false,

    sellerPermitFile: null,  // Actual File object

    businessLicenseFile: null, // Actual File object

    healthPermitFile: null,  // Actual File object

    foodHandlerFile: null,   // Actual File object

    charitySelection: '',

    licensePlateNumber: '',

    productType: ''

  });



  // Store files in IndexedDB for persistence across Stripe redirect

  // File objects must be converted to ArrayBuffer for storage

  const storeFilesForUpload = async (email, files) => {

    try {

      // Convert File objects to storable format (ArrayBuffer + metadata)

      const serializedFiles = {};

      for (const [key, file] of Object.entries(files)) {

        if (file instanceof File) {

          const arrayBuffer = await file.arrayBuffer();

          serializedFiles[key] = {

            data: arrayBuffer,

            name: file.name,

            type: file.type,

            lastModified: file.lastModified

          };

        }

      }

      console.log('[storeFilesForUpload] Serialized files:', Object.keys(serializedFiles));

      // CRITICAL: Wrap IndexedDB in a Promise so await actually waits for the write
      // Without this, the page navigates to /cart before data is saved!
      const writeToDb = (version) => new Promise((resolve, reject) => {
        const dbRequest = indexedDB.open('VendorDocuments', version);

        dbRequest.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('pendingUploads')) {
            db.createObjectStore('pendingUploads', { keyPath: 'email' });
          }
        };

        dbRequest.onsuccess = (event) => {
          const db = event.target.result;

          // If the store doesn't exist (DB was created by old code without it),
          // close, delete, and re-open to force onupgradeneeded
          if (!db.objectStoreNames.contains('pendingUploads')) {
            console.log('[storeFilesForUpload] Store missing, recreating DB...');
            db.close();
            const delReq = indexedDB.deleteDatabase('VendorDocuments');
            delReq.onsuccess = () => writeToDb(1).then(resolve, reject);
            delReq.onerror = () => reject(delReq.error);
            return;
          }

          const transaction = db.transaction(['pendingUploads'], 'readwrite');
          const store = transaction.objectStore('pendingUploads');
          store.put({ email: email.toLowerCase(), files: serializedFiles, timestamp: Date.now() });

          transaction.oncomplete = () => {
            console.log('[storeFilesForUpload] SUCCESS - files stored in IndexedDB:', Object.keys(serializedFiles));
            resolve();
          };
          transaction.onerror = () => {
            console.error('[storeFilesForUpload] Transaction error:', transaction.error);
            reject(transaction.error);
          };
        };

        dbRequest.onerror = (event) => {
          console.error('[storeFilesForUpload] IndexedDB open error:', event.target.error);
          reject(event.target.error);
        };
      });
      await writeToDb(1);

    } catch (err) {

      console.error('Failed to store files in IndexedDB:', err);

    }

  };



  const bazaarBusinessTypes = [

    'Arab Boutique',

    'North African Boutique',

    'American Boutique',

    "Men's Boutique",

    "Women's Boutique",

    'Hijab, Accessories, and Jewellery',

    'Books',

    'Business',

    'Art Items',

    'Kids',

    'Perfumes/Oils',

    'Other'

  ];



  const foodTruckBusinessTypes = [

    'Arab Food',

    'North African Food',

    'American Food',

    'General Food',

    'Dessert',

    'Beverage'

  ];



  const setupTermsText = 'Vendor shall obtain and maintain, at Vendor\'s sole cost, all required licenses and permits, including but not limited to a valid California Seller\'s Permit and a Business Tax Certificate or temporary business license issued by the City of Costa Mesa, California. Food vendors and food trucks must additionally obtain all required health and safety permits from Orange County Environmental Health. Failure to provide required documentation may result in denial of setup or removal from the Event without refund.*';

  const handwashText = 'I will bring a handwashing station for my booth which is required by OC Health Department. I can get a 5 Gallon water dispenser with a tap on the bottle and a collection vessel for used water*';

  const presentationText = 'I will review the following link to understand the OC Health Department\'s requirements. The link will also be provided to me on my confirmation email: https://ochealthinfo.com/services-programs/environmental-health/food-and-pool/food/food-safety-programs/food-booths *';

  const bdsDisclaimerText = 'I confirm that my products and ingredients comply with the Boycott, Divestment, and Sanctions (BDS) guidelines and do not knowingly include prohibited goods or brands. The following link will also be provided to me on my confirmation email: https://bdsmovement.net/Guide-to-BDS-Boycott *';



  // Pre-fill form with logged-in user data

  useEffect(() => {

    if (isAuthenticated && user) {

      const nameParts = (user.full_name || '').trim().split(/\s+/);
      setFormData(prev => ({

        ...prev,

        email: user.email || prev.email,

        firstName: prev.firstName || nameParts[0] || '',

        lastName: prev.lastName || nameParts.slice(1).join(' ') || '',

        phone: user.phone || prev.phone

      }));

    }

  }, [isAuthenticated, user]);



  // Day selection removed - all booths are 3 days fixed price



  const handleUpgradeChange = (boothId) => {

    setUpgrades(prev => ({

      ...prev,

      [boothId]: !prev[boothId]

    }));

  };



  const handleHalalChange = (boothId) => {

    setHalal(prev => ({

      ...prev,

      [boothId]: !prev[boothId]

    }));

  };



  const getBusinessTypeOptions = (boothId) => {

    if (boothId === 'food-truck' || boothId === 'food-booth' || boothId === 'food-booth-20x20' || boothId === 'food-booth-20x10') return foodTruckBusinessTypes;

    return bazaarBusinessTypes;

  };



  const handleSelect = (boothId) => {

    // Just select the booth, don't show registration form

    setSelectedBooth(boothId);

  };



  const handleContinue = () => {

    // Show registration form when clicking Continue on selected booth

    if (selectedBooth) {

      const defaultBusinessType = getBusinessTypeOptions(selectedBooth)[0];

      setFormData(prev => ({

        ...prev,

        businessType: defaultBusinessType,

        sameAsLegal: false,

        setupAccepted: false,

        handwashAccepted: false,

        presentationAccepted: false,

        bdsAccepted: false,

        healthPermit: false,

        sellerPermitFile: '',

        businessLicenseFile: '',

        healthPermitFile: '',

        foodHandlerFile: ''

      }));

      setShowRegistration(true);

    }

  };



  const handleFormChange = (field, value) => {

    setFormData(prev => {

      const updated = { ...prev, [field]: value };



      if (field === 'sameAsLegal') {

        if (value) {

          updated.boothName = prev.legalName || prev.boothName;

        }

      }



      if (field === 'legalName' && prev.sameAsLegal) {

        updated.boothName = value;

      }



      return updated;

    });

  };





  const calculateBoothPrice = (boothId) => {

    const booth = boothOptions.find(b => b.id === boothId);

    if (!booth) return 0;

    

    // Use sale price if available, otherwise use regular price

    let price = booth.salePrice || booth.price;

    

    // Add upgrade cost if selected

    if (upgrades[boothId]) {

      if (boothId === 'bazaar') price += 100;

      if (boothId === 'food-booth') price += 200;

    }

    

    // All booths are fixed at 3 days - no day adjustment

    return price;

  };



  const [isProcessing, setIsProcessing] = useState(false); // eslint-disable-line no-unused-vars

  const [checkoutError, setCheckoutError] = useState(''); // eslint-disable-line no-unused-vars



  const handleContinueToCheckout = async () => {
    // CRITICAL: Prevent double-clicks
    if (isProcessing) return;

    // Validate form

    const missing = [];
    if (!formData.firstName) missing.push('First Name');
    if (!formData.lastName) missing.push('Last Name');
    if (!formData.email) missing.push('Email');
    if (!formData.phone) missing.push('Phone Number');
    if (!formData.legalName) missing.push('Legal Business Name');
    if (selectedBooth === 'food-truck' && !formData.licensePlateNumber) missing.push('License Plate Number');
    if (missing.length > 0) {
      toast.error(`Please fill in: ${missing.join(', ')}`);
      return;
    }

    // Check vendor eligibility by contact email before proceeding
    try {
      const eligibility = await api.checkVendorEligibility(formData.email);
      if (eligibility?.success && !eligibility.eligible) {
        toast.error(eligibility.message || 'This email already has a vendor booth application.');
        return;
      }
    } catch (err) {
      console.error('Vendor eligibility check failed:', err);
      // Allow to continue if check fails (network error etc.)
    }



    // Validate required consents per booth type

    const isFoodBooth = selectedBooth === 'food-truck' || selectedBooth === 'food-booth' || selectedBooth === 'food-booth-20x20' || selectedBooth === 'food-booth-20x10';

    





    const consentErrors = [];

    if (!formData.setupAccepted) consentErrors.push('Accept the setup terms');

    if (!formData.bdsAccepted) consentErrors.push('Accept the BDS compliance disclaimer');

    if (!formData.rightOfRefusalAccepted) consentErrors.push('Accept the Right of Refusal disclaimer');

    if (isFoodBooth) {

      if (!formData.handwashAccepted) consentErrors.push('Accept the handwashing station requirement');

      if (!formData.presentationAccepted) consentErrors.push('Acknowledge the OC Health Department requirement');

    }



    if (consentErrors.length > 0) {

      toast.error('Please accept the required terms to continue');

      return;

    }



    setIsProcessing(true);

    setCheckoutError('');

    

    const booth = boothOptions.find(b => b.id === selectedBooth);

    const price = calculateBoothPrice(selectedBooth);

    const daysLabel = 'Fri-Sun (3 days)'; // All booths are 3 days

    

    // Determine business type for backend

    const businessTypeMap = {

      'bazaar': 'bazaar',

      'bazaar-20x20': 'bazaar',

      'bazaar-20x10': 'bazaar',

      'food-truck': 'food',

      'food-booth': 'food',

      'food-booth-20x20': 'food',

      'food-booth-20x10': 'food'

    };

    const businessType = businessTypeMap[selectedBooth] || 'vendor';

    // Determine booth size based on booth type and upgrades

    let boothSize = '10x10'; // Default size

    if (selectedBooth.includes('20x20')) {

      boothSize = '20x20'; // Fixed 20x20 booths

    } else if (selectedBooth.includes('20x10')) {

      boothSize = '20x10'; // Fixed 20x10 booths

    } else if (upgrades[selectedBooth]) {

      boothSize = '20x10'; // Upgraded booths (bazaar or food-booth)

    }

    

    // Create cart item with flat structure matching backend expectations

    const boothCartItem = {

      id: `booth-${selectedBooth}-${Date.now()}`,

      ticket_type_id: null,

      name: `${booth.name} - ${daysLabel}`,

      quantity: 1,

      price: price,

      type: 'vendor-booth',

      // Flat fields for backend processing

      business_type: businessType,

      business_name: formData.boothName || formData.legalName,

      booth_size: boothSize,

      booth_type: selectedBooth,

      days: '3days', // All booths are 3 days fixed

      halal_certified: halal[selectedBooth] || false,

      // Vendor contact info

      vendor_name: `${formData.firstName} ${formData.lastName}`.trim(),

      vendor_first_name: formData.firstName,

      vendor_last_name: formData.lastName,

      vendor_email: formData.email,

      vendor_phone: formData.phone,

      legal_name: formData.legalName,

      instagram: formData.instagram || '',

      facebook: formData.facebook || '',

      tiktok: formData.tiktok || '',

      business_subtype: formData.businessType === 'Other' && formData.otherBusinessType ? `Other: ${formData.otherBusinessType}` : formData.businessType,

      same_as_legal: formData.sameAsLegal,

      health_permit: formData.healthPermit,

      handwashing_station: formData.handwashAccepted,

      oc_health_presentation: formData.presentationAccepted,

      bds_compliance: formData.bdsAccepted,

      right_of_refusal: formData.rightOfRefusalAccepted,

      charity_selection: formData.charitySelection || '',

      setup_terms: formData.setupAccepted,

      license_plate_number: selectedBooth === 'food-truck' ? formData.licensePlateNumber : '',

      product_type: (selectedBooth === 'food-booth' || selectedBooth === 'food-booth-20x20' || selectedBooth === 'food-booth-20x10') ? formData.productType : '',

      seller_permit_file: formData.sellerPermitFile,

      business_license_file: formData.businessLicenseFile,

      health_permit_file: formData.healthPermitFile,

      food_handler_file: formData.foodHandlerFile

    };

    

    // Vendor booth is mutually exclusive with tickets — clear ALL existing items (festival + amphitheater)
    // Only keep other vendor booth items if any
    let cartItems = [boothCartItem];

    const total = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

    

    // Save to localStorage — strip File objects (can't be JSON-serialized; files stored in IndexedDB separately)

    const cartForStorage = cartItems.map(item => {
      const { seller_permit_file, business_license_file, health_permit_file, food_handler_file, ...rest } = item;
      return rest;
    });

    localStorage.setItem('cart', JSON.stringify({

      items: cartForStorage,

      total: total

    }));

    

    // ── Meta Pixel: AddToCart ──
    trackAddToCart({
      contentName: boothCartItem.name,
      contentIds: [boothCartItem.id],
      value: total,
      currency: 'USD',
      numItems: 1,
      userData: { email: formData.email, phone: formData.phone, firstName: formData.firstName, lastName: formData.lastName },
    });

    // Dispatch cart update event

    window.dispatchEvent(new CustomEvent('cartUpdated', { 

      detail: { items: cartItems, total: total } 

    }));

    

    // Store files in IndexedDB before redirecting to Stripe (since state is lost on redirect)

    if (formData.sellerPermitFile || formData.businessLicenseFile || formData.healthPermitFile || formData.foodHandlerFile) {

      const filesToStore = {};

      if (formData.sellerPermitFile) filesToStore.sellerPermit = formData.sellerPermitFile;

      if (formData.businessLicenseFile) filesToStore.businessLicense = formData.businessLicenseFile;

      if (formData.healthPermitFile) filesToStore.healthPermit = formData.healthPermitFile;

      if (formData.foodHandlerFile) filesToStore.foodHandler = formData.foodHandlerFile;

      await storeFilesForUpload(formData.email, filesToStore);

    }



    // Navigate to /cart page — same flow as festival/amphitheater tickets
    // Cart page handles auth modal → Stripe checkout
    setIsProcessing(false);
    window.location.href = '/cart';

  };





  const getStockThreshold = (boothId) => {
    if (boothId.includes('20x20') || boothId.includes('20x10')) return 4;
    return 10;
  };



  const [boothOptions, setBoothOptions] = useState([

    {

      id: 'bazaar',

      name: '10x10 Bazaar Booth',

      description: 'Sell goods inside the decorated bazaar',

      price: 500,

      salePrice: null,

      saleMessage: '',

      totalQuantity: 144,

      soldCount: 0,

      includes: [

        '10x10 booth',

        'Vendor credentials'

      ],

      hasUpgrade: false,

      hasHalal: false

    },

    {

      id: 'food-truck',

      name: 'Food/Beverage Truck',

      description: 'Serve guests from your mobile kitchen',

      price: 2000,

      salePrice: null,

      saleMessage: '',

      totalQuantity: 23,

      soldCount: 0,

      includes: [

        'Food/Beverage truck parking spot',

        'Vendor credentials'

      ],

      hasUpgrade: false,

      hasHalal: true

    },

    {

      id: 'food-booth',

      name: '10x10 Food/Beverage Booth',

      description: 'Serve food from a fixed booth space',

      price: 1000,

      salePrice: null,

      saleMessage: '',

      totalQuantity: 38,

      soldCount: 0,

      includes: [

        '10x10 booth',

        'Vendor credentials'

      ],

      hasUpgrade: false,

      hasHalal: true

    },

    {

      id: 'bazaar-20x20',

      name: '20x20 Bazaar Booth',

      description: 'Extra-large 20x20 booth inside the decorated bazaar',

      price: 1000,

      salePrice: null,

      saleMessage: '',

      totalQuantity: 4,

      soldCount: 0,

      includes: [

        '20x20 booth',

        'Vendor credentials'

      ],

      hasUpgrade: false,

      hasHalal: false

    },

    {

      id: 'food-booth-20x20',

      name: '20x20 Food/Beverage Booth',

      description: 'Extra-large 20x20 booth for food service',

      price: 2000,

      salePrice: null,

      saleMessage: '',

      totalQuantity: 4,

      soldCount: 0,

      includes: [

        '20x20 booth',

        'Vendor credentials'

      ],

      hasUpgrade: false,

      hasHalal: true

    },

    {

      id: 'bazaar-20x10',

      name: '20x10 Bazaar Booth',

      description: 'Spacious 20x10 booth inside the decorated bazaar',

      price: 750,

      salePrice: null,

      saleMessage: '',

      totalQuantity: 4,

      soldCount: 0,

      includes: [

        '20x10 booth',

        'Vendor credentials'

      ],

      hasUpgrade: false,

      hasHalal: false

    },

    {

      id: 'food-booth-20x10',

      name: '20x10 Food/Beverage Booth',

      description: 'Spacious 20x10 booth for food service',

      price: 1500,

      salePrice: null,

      saleMessage: '',

      totalQuantity: 4,

      soldCount: 0,

      includes: [

        '20x10 booth',

        'Vendor credentials'

      ],

      hasUpgrade: false,

      hasHalal: true

    }

  ]);

  // If a filter is provided, auto-select the first allowed booth once options are loaded
  useEffect(() => {
    if (!allowedBooths || selectedBooth) return;
    const firstAllowed = boothOptions.find(b => allowedBooths.includes(b.id));
    if (firstAllowed) setSelectedBooth(firstAllowed.id);
  }, [allowedBooths, boothOptions, selectedBooth]);

  const visibleBooths = useMemo(() => {
    const filtered = allowedBooths ? boothOptions.filter(b => allowedBooths.includes(b.id)) : [...boothOptions];
    return filtered.sort((a, b) => {
      // Food/Beverage truck always goes to the bottom
      if (a.id === 'food-truck') return 1;
      if (b.id === 'food-truck') return -1;
      // Everything else sorted lowest to highest price
      const priceA = a.salePrice || a.price;
      const priceB = b.salePrice || b.price;
      return priceA - priceB;
    });
  }, [allowedBooths, boothOptions]);



  // Fetch vendor booth pricing from backend - real-time updates

  const fetchVendorPricing = async () => {

    try {

      const response = await api.getVendorTicketTypes();

      console.log('VendorBooths: API response:', response);

      

      if (response.success && response.data) {

        console.log('VendorBooths: Received ticket types:', response.data.map(t => ({ slug: t.slug, price_cents: t.price_cents, sale_price: t.sale_price })));

        

        // Map backend ticket types to booth options

        setBoothOptions(prevBooths => prevBooths.map(booth => {

          // Find 3-day ticket type for this booth

          const slug3day = `${booth.id}-3day`;

          const ticketType = response.data.find(t => t.slug === slug3day);

          

          console.log(`VendorBooths: Looking for slug "${slug3day}", found:`, ticketType ? { slug: ticketType.slug, price_cents: ticketType.price_cents } : 'NOT FOUND');

          

          if (ticketType) {

            const approvedCount = Number.isFinite(ticketType.approved_count)
              ? ticketType.approved_count
              : (ticketType.sold_count || 0);
            console.log(`VendorBooths: Updating ${booth.id} price=${ticketType.price_cents}, salePrice=${ticketType.sale_price_cents}, approvedCount=${approvedCount}, capacity=${ticketType.capacity}`);

            return {

              ...booth,

              price: ticketType.price_cents ? ticketType.price_cents / 100 : booth.price,

              salePrice: ticketType.sale_price_cents ? ticketType.sale_price_cents / 100 : null,

              saleMessage: ticketType.sale_message || booth.saleMessage,

              totalQuantity: ticketType.capacity || booth.totalQuantity,

              soldCount: approvedCount

            };

          }

          console.log(`VendorBooths: No ticket type found for ${booth.id}, keeping default price $${booth.price}`);

          return booth;

        }));

      } else {

        console.warn('VendorBooths: API returned no data or failed:', response);

      }

    } catch (error) {

      console.error('VendorBooths: Failed to fetch vendor pricing:', error);

    }

  };



  // Fetch on mount and when page becomes visible (real-time sync)

  useEffect(() => {

    fetchVendorPricing();

    

    // Refetch when page becomes visible (user switches back to tab)

    const handleVisibilityChange = () => {

      if (document.visibilityState === 'visible') {

        fetchVendorPricing();

      }

    };

    

    // Refetch when window gains focus

    const handleFocus = () => {

      fetchVendorPricing();

    };

    

    document.addEventListener('visibilitychange', handleVisibilityChange);

    window.addEventListener('focus', handleFocus);

    

    // Poll every 30 seconds for real-time updates

    const pollInterval = setInterval(fetchVendorPricing, 30000);

    

    return () => {

      document.removeEventListener('visibilitychange', handleVisibilityChange);

      window.removeEventListener('focus', handleFocus);

      clearInterval(pollInterval);

    };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);



  return (

    <div className="page-wrapper">

      <AnnouncementBar />

      

      <section className="hero-section">

        <div className="hero-background-wrapper">

          <video src={"/hero-final.mp4"} alt="OC MENA Festival" className="hero-background-video" autoPlay muted loop playsInline />

          <div className="hero-gradient-overlay"></div>

        </div>



        <TornPaperWrapper>

          <style dangerouslySetInnerHTML={{

            __html: `

              .card-description {

                color: #333 !important;

              }

              .vendor-section-title {

                color: #1f2022 !important;

              }

              .booth-card .checkbox-input:checked ~ .checkbox-custom:after,

              .booth-card .checkbox-input:checked + .checkbox-custom:after {

                content: "✓" !important;

                display: block !important;

                color: #475569 !important;

                font-size: 16px !important;

                font-weight: bold !important;

                position: absolute !important;

                top: 50% !important;

                left: 50% !important;

                transform: translate(-50%, -50%) !important;

                background: none !important;

                border: none !important;

                width: auto !important;

                height: auto !important;

              }

              .booth-card .checkbox-input:checked ~ .checkbox-custom,

              .booth-card .checkbox-input:checked + .checkbox-custom {

                background-color: transparent !important;

                border-color: #475569 !important;

                outline: none !important;

              }

              .booth-card .checkbox-custom:after:before,

              .booth-card .checkbox-custom:before,

              .booth-card .checkbox-custom:after:after,

              .booth-card .checkbox-custom *:before,

              .booth-card .checkbox-custom *:after {

                display: none !important;

                content: none !important;

              }

              .booth-card .checkbox-input:focus,

              .booth-card .checkbox-input:focus ~ .checkbox-custom {

                outline: none !important;

                box-shadow: none !important;

              }

            `

          }} />

          <h1 className="card-title">{vb.title || 'OC MENA Festival Vendor Booths'} <span className="arabic-text on-white">{getArabicTranslation('OC MENA Festival Vendor Booths')}</span></h1>

          <p className="card-description" style={{color: '#333', important: true}}>

            Join us at the OC MENA Festival, one of Orange County's most exciting cultural events, bringing together thousands of families and visitors for three days of food, shopping, music, and entertainment inspired by the Middle East and North Africa.

          </p>

          <p className="card-description" style={{color: '#333', important: true}}>

            Showcase your products, cuisine, services, or brand in a vibrant festival environment filled with energy and community engagement. With a variety of booth options available, vendors can choose the ideal space to connect with guests, drive sales, and be part of an unforgettable summer celebration.

          </p>

          <p className="card-description" style={{color: '#333', important: true}}>

            Explore the booth packages and secure your spot today—spaces are limited and fill quickly each year.

          </p>

          

          {!showRegistration ? (

          <>
            <h2 className="booths-title">Please select a booth option:</h2>

            <div className="booths-container">

              {visibleBooths.map(booth => (

                <div key={booth.id} className={`booth-card ${selectedBooth === booth.id ? 'selected' : ''}`} onClick={() => handleSelect(booth.id)} style={{cursor: 'pointer', position: 'relative'}}>

                  {selectedBooth === booth.id && (

                    <div className="selected-checkmark">✓</div>

                  )}

                  {booth.salePrice && (

                    <div style={{

                      position: 'absolute',

                      right: '20px',

                      background: '#dc2626',

                      color: 'white',

                      padding: '6px 12px',

                      borderRadius: '20px',

                      fontSize: '12px',

                      fontWeight: 'bold',

                      zIndex: 10,

                      boxShadow: '0 2px 8px rgba(220, 38, 38, 0.3)'

                    }}>

                      🔥 SALE

                    </div>

                  )}

                  <div className="booth-header">

                    <h3 className="booth-name">{booth.name}</h3>

                    <p className="booth-description">{booth.description}</p>

                    

                  </div>

                  

                  <div className="booth-details" style={{marginBottom: '0', paddingBottom: '0'}}>

                    {/* All booths are 3 days - Fri-Sun */}

                    <div className="booth-section" style={{marginBottom: '10px'}}>

                      <div className="vendor-section-title" style={{background: 'transparent', fontSize: '12.7px', fontWeight: '600'}}>Duration</div>

                      <p style={{margin: '5px 0', fontSize: '14px', color: '#333'}}>Fri-Sun (3 days)</p>

                    </div>



                    <div className="booth-section" style={{marginTop: '15px', marginBottom: '25px'}}>

                      <div className="vendor-section-title" style={{background: 'transparent', fontSize: '12.7px', fontWeight: '600', marginBottom: '0'}}>Includes</div>

                      <ul className="includes-list">

                        {booth.includes.map((item, index) => (

                          <li key={index}>{item}</li>

                        ))}

                      </ul>

                    </div>



                    {booth.hasHalal && (

                      <div className="booth-section">

                        <div className="vendor-section-title" style={{background: 'transparent', fontSize: '12.7px', fontWeight: '600'}}>Do you serve Halal food?</div>

                        <label className="checkbox-label" onClick={(e) => e.stopPropagation()}>

                          <input

                            type="checkbox"

                            checked={halal[booth.id]}

                            onChange={(e) => {

                              e.stopPropagation();

                              handleHalalChange(booth.id);

                            }}

                            className="checkbox-input"

                          />

                          <span className="checkbox-custom"></span>

                          <span>Yes (not a requirement)</span>

                        </label>

                      </div>

                    )}



                    {booth.hasUpgrade && (

                      <div className="booth-section">

                        <div className="vendor-section-title" style={{background: 'transparent', fontSize: '12.7px', fontWeight: '600'}}>Do you need more space?</div>

                        <label className="checkbox-label" onClick={(e) => e.stopPropagation()}>

                          <input

                            type="checkbox"

                            checked={upgrades[booth.id]}

                            onChange={(e) => {

                              e.stopPropagation();

                              handleUpgradeChange(booth.id);

                            }}

                            className="checkbox-input"

                          />

                          <span className="checkbox-custom"></span>

                          <span>{booth.upgradeText}</span>

                        </label>

                      </div>

                    )}

                  </div>



                  {/* Price Display - Always Visible Below Card Content */}

                  <div className="booth-pricing" style={{

                    marginTop: 'auto',

                    paddingTop: '15px'

                  }}>

                    {booth.salePrice ? (

                      <>

                        {booth.saleMessage && (

                          <div style={{

                            padding: '8px 12px',

                            backgroundColor: '#dcfce7',

                           

                            borderRadius: '6px',

                            fontSize: '13px',

                            color: '#166534',

                            fontWeight: '500',

                            textAlign: 'center',

                            marginBottom: '15px'

                          }}>

                            {booth.saleMessage}

                          </div>

                        )}

                        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'flex-end', gap: '10px', marginBottom: '0px' }}>

                          {(() => {
                            const saleRemaining = booth.totalQuantity - booth.soldCount;
                            const saleThreshold = getStockThreshold(booth.id);
                            if (saleRemaining <= 0) {
                              return (
                                <div style={{margin: '0px', borderRadius: '6px', display: 'inline-block', marginRight: 'auto'}}>
                                  <span style={{color: '#dc2626', fontWeight: 700, fontSize: '13px'}}>
                                    SOLD OUT
                                  </span>
                                </div>
                              );
                            }
                            if (saleRemaining > 0 && saleRemaining <= saleThreshold) {
                              return (
                                <div style={{margin: '0px', borderRadius: '6px', display: 'inline-block', marginRight: 'auto'}}>
                                  <span style={{color: 'rgb(216, 119, 6)', fontWeight: 700, fontSize: '13px'}}>
                                    <svg fill="currentColor" viewBox="0 0 24 24" style={{width: '18px', height: '18px', marginRight: '4px', verticalAlign: 'middle'}}>
                                      <path d="M12 2L1 21h22L12 2zm0 4l7.53 13H4.47L12 6zm-1 8h2v2h-2v-2zm0-4h2v2h-2V10z"></path>
                                    </svg>
                                    Only {saleRemaining} left!
                                  </span>
                                </div>
                              );
                            }
                            return null;
                          })()}

                          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'flex-end', gap: '10px' }}>

                            <span style={{

                              fontSize: '16px',

                              color: 'rgb(153, 153, 153)',

                              textDecoration: 'line-through'

                            }}>

                              ${(booth.price + (upgrades[booth.id] ? (booth.id === 'bazaar' ? 100 : booth.id === 'food-booth' ? 200 : 0) : 0)).toLocaleString()}

                            </span>

                            <span className="booth-price" style={{ fontSize: '20px', fontWeight: '600', color: 'rgb(51, 51, 51)', display: 'block', marginBottom: '0px', textAlign: 'right', whiteSpace: 'nowrap', lineHeight: '100%' }}>

                              ${calculateBoothPrice(booth.id).toLocaleString()}

                            </span>

                          </div>

                        </div>

                      </>

                    ) : (

                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>

                        {(() => {

                          const remaining = booth.totalQuantity - booth.soldCount;

                          const threshold = getStockThreshold(booth.id);

                          if (remaining <= 0) {

                            return (

                              <div style={{margin: '0', borderRadius: '6px', display: 'inline-block', marginRight: 'auto'}}>

                                <span style={{color: '#dc2626', fontWeight: 700, fontSize: '13px'}}>

                                  SOLD OUT

                                </span>

                              </div>

                            );

                          }

                          if (remaining > 0 && remaining <= threshold) {

                            return (

                              <div style={{margin: '0', borderRadius: '6px', display: 'inline-block', marginRight: 'auto'}}>

                                <span style={{color: '#D87706', fontWeight: 700, fontSize: '13px'}}>

                                  <svg style={{width: '18px', height: '18px', marginRight: '4px', verticalAlign: 'middle'}} fill="currentColor" viewBox="0 0 24 24">

                                    <path d="M12 2L1 21h22L12 2zm0 4l7.53 13H4.47L12 6zm-1 8h2v2h-2v-2zm0-4h2v2h-2V10z"/>

                                  </svg>

                                  Only {remaining} left!

                                </span>

                              </div>

                            );

                          }

                          return null;

                        })()}

                        <span className="booth-price" style={{ fontSize: '20px', fontWeight: '600', color: '#333', display: 'block', marginBottom: '0', textAlign: 'right', whiteSpace: 'nowrap', lineHeight: '100%', letterSpacing: '0%' }}>

                          ${calculateBoothPrice(booth.id).toLocaleString()}

                        </span>

                      </div>

                    )}

                  </div>



                  <button

                    className={`select-btn ${selectedBooth === booth.id ? 'selected' : ''} sold-out`}

                    disabled={true}

                    onClick={(e) => {

                      e.stopPropagation();

                      if ((booth.totalQuantity - booth.soldCount) <= 0) return;

                      if (selectedBooth === booth.id) {

                        handleContinue();

                      } else {

                        handleSelect(booth.id);

                      }

                    }}

                    style={{}}

                  >

                    Sold Out

                  </button>

                </div>

              ))}

            </div>

          </>

        ) : (

          <div className="registration-form">

            <h3>Vendor Registration</h3>



            <div className="form-group">

              <label className="form-label">Choose what fits your business*</label>

              <select

                className="form-select"

                value={formData.businessType}

                onChange={(e) => handleFormChange('businessType', e.target.value)}

              >

                {getBusinessTypeOptions(selectedBooth).map(option => (

                  <option key={option} value={option}>{option}</option>

                ))}

              </select>

              {formData.businessType === 'Other' && (
                <input
                  type="text"
                  className="form-input"
                  placeholder="Please specify your business type"
                  value={formData.otherBusinessType || ''}
                  onChange={(e) => handleFormChange('otherBusinessType', e.target.value)}
                  style={{marginTop: '0.5rem'}}
                />
              )}

            </div>



            <div className="form-group">

              <label className="form-label">First Name*</label>

              <input 

                type="text" 

                className="form-input" 

                placeholder="First name"

                value={formData.firstName}

                onChange={(e) => handleFormChange('firstName', e.target.value)}

              />

            </div>



            <div className="form-group">

              <label className="form-label">Last Name*</label>

              <input 

                type="text" 

                className="form-input" 

                placeholder="Last name"

                value={formData.lastName}

                onChange={(e) => handleFormChange('lastName', e.target.value)}

              />

            </div>



            <div className="form-group">

              <label className="form-label">Contact Email*</label>

              <input 

                type="email" 

                className="form-input" 

                placeholder="your@email.com"

                value={formData.email}

                onChange={(e) => handleFormChange('email', e.target.value)}

              />

            </div>



            <div className="form-group">

              <label className="form-label">Legal Business Name*</label>

              <input 

                type="text" 

                className="form-input" 

                placeholder="Your legal business name"

                value={formData.legalName}

                onChange={(e) => handleFormChange('legalName', e.target.value)}

              />

            </div>



            <div className="form-group">

              <label className="form-label">Booth Name</label>

              <input 

                type="text" 

                className="form-input" 

                placeholder="Your booth display name"

                value={formData.boothName}

                onChange={(e) => handleFormChange('boothName', e.target.value)}

              />

            </div>



            <div className="form-group checkbox-row">

              <label className="checkbox-label" style={{ paddingLeft: '28px' }}>

                <input

                  type="checkbox"

                  className="checkbox-input"

                  checked={formData.sameAsLegal}

                  onChange={(e) => handleFormChange('sameAsLegal', e.target.checked)}

                />

                <span className="checkbox-custom"></span>

                <span>Same as legal business name?</span>

              </label>

            </div>



            <div className="form-group">

              <label className="form-label">Phone Number*</label>

              <input 

                type="tel" 

                className="form-input" 

                placeholder="(555) 123-4567"

                value={formData.phone}

                onChange={(e) => handleFormChange('phone', e.target.value)}

              />

            </div>



            <div className="form-group">

              <label className="form-label">Instagram Handle</label>

              <input 

                type="text" 

                className="form-input" 

                placeholder="@yourbusiness"

                value={formData.instagram}

                onChange={(e) => handleFormChange('instagram', e.target.value)}

              />

            </div>



            <div className="form-group">

              <label className="form-label">Facebook Handle</label>

              <input 

                type="text" 

                className="form-input" 

                placeholder="facebook.com/yourbusiness"

                value={formData.facebook}

                onChange={(e) => handleFormChange('facebook', e.target.value)}

              />

            </div>



            <div className="form-group">

              <label className="form-label">TikTok Handle</label>

              <input 

                type="text" 

                className="form-input" 

                placeholder="@yourbusiness"

                value={formData.tiktok}

                onChange={(e) => handleFormChange('tiktok', e.target.value)}

              />

            </div>



            {/* License Plate - only for food trucks */}
            {selectedBooth === 'food-truck' && (
              <div className="form-group">
                <label className="form-label">License Plate Number*</label>
                <input 
                  type="text" 
                  className="form-input" 
                  placeholder="e.g. 7ABC123"
                  value={formData.licensePlateNumber}
                  onChange={(e) => handleFormChange('licensePlateNumber', e.target.value)}
                />
              </div>
            )}

            {/* Product Type - only for food booths (NOT food trucks) */}
            {(selectedBooth === 'food-booth' || selectedBooth === 'food-booth-20x20' || selectedBooth === 'food-booth-20x10') && (
              <div className="form-group">
                <label className="form-label">Product Type*</label>
                <select
                  className="form-select"
                  value={formData.productType}
                  onChange={(e) => handleFormChange('productType', e.target.value)}
                >
                  <option value="">Select product type...</option>
                  <option value="prepackaged">Prepackaged (Bazaar section)</option>
                  <option value="prepackaged_sampling">Prepackaged with Open Sampling (Bazaar section)</option>
                  <option value="unpackaged">Unpackaged/Open Food (Food Court section)</option>
                </select>
              </div>
            )}

            {/* === Document Uploads - ALL booth types need seller's permit and business license === */}

            <div className="form-consent form-consent--upload">

              <p className="consent-text"><strong>Upload Seller's Permit (Optional)</strong></p>

              <div style={{ position: 'relative' }}>
                <input

                  type="file"

                  accept=".pdf,.jpg,.jpeg,.png"

                  className="form-input"

                  style={{ 
                    opacity: '0',
                    position: 'absolute',
                    zIndex: '1',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                  }}

                  onChange={(e) => {
                    handleFormChange('sellerPermitFile', e.target.files?.[0] || null);
                    // Update the display text
                    const fileName = e.target.files?.[0]?.name || 'No file chosen';
                    document.getElementById('sellerPermitFileName').textContent = fileName;
                  }}

                  id="sellerPermitInput"
                />
                <div 
                  className="form-input"
                  style={{ 
                    pointerEvents: 'none',
                    textAlign: 'left',
                    color: '#2c3e50',
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '40px',
                    backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12'%3E%3C/path%3E%3C/svg%3E\")",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '16px 16px'
                  }}
                  id="sellerPermitFileName"
                >
                  No file chosen
                </div>
              </div>

              {formData.sellerPermitFile && <div style={{color: '#16a34a', fontSize: '12px', marginTop: '4px'}}>✓ {formData.sellerPermitFile.name}</div>}

              <div className="upload-note">You can add this later in your dashboard</div>

            </div>



            <div className="form-consent form-consent--upload">

              <p className="consent-text"><strong>Upload Business License or Tax Certificate (Optional)</strong></p>

              <div style={{ position: 'relative' }}>
                <input

                  type="file"

                  accept=".pdf,.jpg,.jpeg,.png"

                  className="form-input"

                  style={{ 
                    opacity: '0',
                    position: 'absolute',
                    zIndex: '1',
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer'
                  }}

                  onChange={(e) => {
                    handleFormChange('businessLicenseFile', e.target.files?.[0] || null);
                    // Update the display text
                    const fileName = e.target.files?.[0]?.name || 'No file chosen';
                    document.getElementById('businessLicenseFileName').textContent = fileName;
                  }}

                  id="businessLicenseInput"
                />
                <div 
                  className="form-input"
                  style={{ 
                    pointerEvents: 'none',
                    textAlign: 'left',
                    color: '#2c3e50',
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '40px',
                    backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12'%3E%3C/path%3E%3C/svg%3E\")",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 12px center',
                    backgroundSize: '16px 16px'
                  }}
                  id="businessLicenseFileName"
                >
                  No file chosen
                </div>
              </div>

              {formData.businessLicenseFile && <div style={{color: '#16a34a', fontSize: '12px', marginTop: '4px'}}>✓ {formData.businessLicenseFile.name}</div>}

              <div className="upload-note">You can add this later in your dashboard</div>

            </div>



            {/* === Food-specific uploads === */}

            {(selectedBooth === 'food-truck' || selectedBooth === 'food-booth' || selectedBooth === 'food-booth-20x20' || selectedBooth === 'food-booth-20x10') && (

              <>

                <div className="form-consent">

                  <p className="consent-text"><strong>Do you have OC Health Permit? (TFF)</strong></p>

                  <label className="checkbox-label" style={{ paddingLeft: '28px' }}>

                    <input

                      type="checkbox"

                      className="checkbox-input"

                      checked={formData.healthPermit}

                      onChange={(e) => handleFormChange('healthPermit', e.target.checked)}

                    />

                    <span className="checkbox-custom"></span>

                    <span>Yes</span>

                  </label>

                </div>



                <div className="form-consent form-consent--upload">

                  <p className="consent-text"><strong>Upload Health Permit</strong></p>

                  <div style={{ position: 'relative' }}>
                    <input

                      type="file"

                      accept=".pdf,.jpg,.jpeg,.png"

                      className="form-input"

                      style={{ 
                        opacity: '0',
                        position: 'absolute',
                        zIndex: '1',
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer'
                      }}

                      onChange={(e) => {
                        handleFormChange('healthPermitFile', e.target.files?.[0] || null);
                        // Update the display text
                        const fileName = e.target.files?.[0]?.name || 'No file chosen';
                        document.getElementById('healthPermitFileName').textContent = fileName;
                      }}

                      id="healthPermitInput"
                    />
                    <div 
                      className="form-input"
                      style={{ 
                        pointerEvents: 'none',
                        textAlign: 'left',
                        color: '#2c3e50',
                        display: 'flex',
                        alignItems: 'center',
                        paddingRight: '40px',
                        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12'%3E%3C/path%3E%3C/svg%3E\")",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 12px center',
                        backgroundSize: '16px 16px'
                      }}
                      id="healthPermitFileName"
                    >
                      No file chosen
                    </div>
                  </div>

                  {formData.healthPermitFile && <div style={{color: '#16a34a', fontSize: '12px', marginTop: '4px'}}>✓ {formData.healthPermitFile.name}</div>}

                  <div className="upload-note">You can add this later in your dashboard</div>

                </div>



                <div className="form-consent form-consent--upload">

                  <p className="consent-text"><strong>Upload Food Handler's Document/Card</strong></p>

                  <div style={{ position: 'relative' }}>
                    <input

                      type="file"

                      accept=".pdf,.jpg,.jpeg,.png"

                      className="form-input"

                      style={{ 
                        opacity: '0',
                        position: 'absolute',
                        zIndex: '1',
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer'
                      }}

                      onChange={(e) => {
                        handleFormChange('foodHandlerFile', e.target.files?.[0] || null);
                        // Update the display text
                        const fileName = e.target.files?.[0]?.name || 'No file chosen';
                        document.getElementById('foodHandlerFileName').textContent = fileName;
                      }}

                      id="foodHandlerInput"
                    />
                    <div 
                      className="form-input"
                      style={{ 
                        pointerEvents: 'none',
                        textAlign: 'left',
                        color: '#2c3e50',
                        display: 'flex',
                        alignItems: 'center',
                        paddingRight: '40px',
                        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12'%3E%3C/path%3E%3C/svg%3E\")",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 12px center',
                        backgroundSize: '16px 16px'
                      }}
                      id="foodHandlerFileName"
                    >
                      No file chosen
                    </div>
                  </div>

                  {formData.foodHandlerFile && <div style={{color: '#16a34a', fontSize: '12px', marginTop: '4px'}}>✓ {formData.foodHandlerFile.name}</div>}

                  <div className="upload-note">You can add this later in your dashboard</div>

                </div>

              </>

            )}



            {/* === Terms & Agreements - ALL booth types === */}

            <div className="form-consent" onClick={() => handleFormChange('setupAccepted', !formData.setupAccepted)} style={{ cursor: 'pointer' }}>

              <p className="consent-text">{setupTermsText}</p>

              <label className="checkbox-label" style={{ paddingLeft: '28px' }} onClick={(e) => e.stopPropagation()}>

                <input

                  type="checkbox"

                  className="checkbox-input"

                  checked={formData.setupAccepted}

                  onChange={(e) => handleFormChange('setupAccepted', e.target.checked)}

                />

                <span className="checkbox-custom"></span>

                <span>I accept the terms above</span>

              </label>

            </div>



            {/* === Food-specific terms === */}

            {(selectedBooth === 'food-truck' || selectedBooth === 'food-booth' || selectedBooth === 'food-booth-20x20' || selectedBooth === 'food-booth-20x10') && (

              <>


                <div className="form-consent" onClick={() => handleFormChange('handwashAccepted', !formData.handwashAccepted)} style={{ cursor: 'pointer' }}>

                  <p className="consent-text">{handwashText}</p>

                  <label className="checkbox-label" style={{ paddingLeft: '28px' }} onClick={(e) => e.stopPropagation()}>

                    <input

                      type="checkbox"

                      className="checkbox-input"

                      checked={formData.handwashAccepted}

                      onChange={(e) => handleFormChange('handwashAccepted', e.target.checked)}

                    />

                    <span className="checkbox-custom"></span>

                    <span>I accept the terms above</span>

                  </label>

                </div>



                <div className="form-consent" onClick={() => handleFormChange('presentationAccepted', !formData.presentationAccepted)} style={{ cursor: 'pointer' }}>

                  <p className="consent-text">{presentationText}</p>

                  <label className="checkbox-label" style={{ paddingLeft: '28px' }} onClick={(e) => e.stopPropagation()}>

                    <input

                      type="checkbox"

                      className="checkbox-input"

                      checked={formData.presentationAccepted}

                      onChange={(e) => handleFormChange('presentationAccepted', e.target.checked)}

                    />

                    <span className="checkbox-custom"></span>

                    <span>I accept the terms above</span>

                  </label>

                </div>

              </>

            )}



            {/* === BDS Compliance Disclaimer - ALL booth types === */}
            <div className="form-consent" onClick={() => handleFormChange('bdsAccepted', !formData.bdsAccepted)} style={{ cursor: 'pointer' }}>
              <p className="consent-text">{bdsDisclaimerText}</p>
              <label className="checkbox-label" style={{ paddingLeft: '28px' }} onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  className="checkbox-input"
                  checked={formData.bdsAccepted}
                  onChange={(e) => handleFormChange('bdsAccepted', e.target.checked)}
                />
                <span className="checkbox-custom"></span>
                <span>I accept the terms above</span>
              </label>
            </div>

            {/* === Right of Refusal Disclaimer - ALL booth types === */}
            <div className="form-consent" onClick={() => handleFormChange('rightOfRefusalAccepted', !formData.rightOfRefusalAccepted)} style={{ cursor: 'pointer' }}>
              <p className="consent-text">Right of Refusal: OC MENA Festival reserves the right to refuse service, deny participation, or cancel a vendor's registration at its sole discretion. If cancellation occurs after a signed agreement, a full refund of vendor fees will be issued.*</p>
              <label className="checkbox-label" style={{ paddingLeft: '28px' }} onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  className="checkbox-input"
                  checked={formData.rightOfRefusalAccepted}
                  onChange={(e) => handleFormChange('rightOfRefusalAccepted', e.target.checked)}
                />
                <span className="checkbox-custom"></span>
                <span>I accept the terms above</span>
              </label>
            </div>

            <button className="continue-btn" onClick={handleContinueToCheckout} disabled={isProcessing}>{isProcessing ? 'Processing...' : 'Continue to Checkout'}</button>

          </div>

        )}

        </TornPaperWrapper>



        <div className="lanterns-container">

          <img loading="lazy" src={getCmsImagePath("lanterns", "/lanterns.webp")} alt="Festival Lanterns" className="lanterns-image" />

        </div>

      </section>



      <SponsorsSection />

      <Footer />

      <ScrollToTop />

    </div>

  );

};



export default VendorBooths;

